export default {
  updatePage: {
    majorUpdateTitle: 'Mise à jour Majeure !',
    majorUpdateMessage: 'Pour accéder à Tokatab, merci de télécharger la nouvelle version depuis les stores.',
    regularUpdateTitle: 'Mise à jour de l\'application',
    regularUpdateMessage: 'Tokatab sera disponible dans quelques secondes !',
  },
  storeMobilePage: {
    accountCreatedTitle: 'Votre compte a bien été créé ! Veuillez installer l\'application pour utiliser Tokatab.',
    subscriptionPrompt: 'Vous souhaitez vous abonner à Tokatab ? Vous êtes au bon endroit !',
    subscribe: 'Je m\'abonne',
    downloadAppTitle: 'Téléchargez l\'application pour utiliser Tokatab !',
    clickLogoIfInstalled: 'Si vous avez déjà l\'application, cliquez sur le logo',
    clickButtonToInstall: 'Cliquez sur le bouton ci-dessous pour l\'installer',
    logout: 'Se déconnecter',
  },
  offlinePage: {
    internetRequired: 'Vous devez être connecté à Internet pour utiliser Tokatab.',
    checkConnection: 'Veuillez vérifier votre connexion avant de réessayer.',
    retry: 'Réessayer'
  },
  maintenancePage: {
    title: 'Maintenance en cours',
    message: 'Nous faisons au plus vite afin de restaurer l\'accès à Tokatab !',
    retry: 'Réessayer'
  },
  errorUpdatePage: {
    title: 'Une erreur est survenue lors de la mise à jour...',
    contactSupport: 'Contactez le support',
    retry: 'Réessayer'
  },
  verifyEmailClient: {
    addressCopied: 'Adresse copiée !',
    copyError: 'Erreur lors de la copie de l\'adresse !',
    contactVia: 'Vous pouvez nous contacter via {email}.',
    copy: 'Copier'
  },
  promotionPopup: {
    onSubscriptions: 'Sur nos <span class="text-yellow-6">abonnements annuel</span> et <span class="text-yellow-6">à vie</span>',
    codeLabel: 'Code promo:',
    validUntil: 'Offre valable jusqu\'au {endDate} inclus !',
    subscribeButton: "Je m'abonne",
    annualSubscription: 'Abonnement annuel',
    monthlySubscription: 'Abonnement mensuel',
    lifetimeSubscription: 'Abonnement à vie',
    perMonth: '(soit {price}/mois)'
  },
  promotionChip: {
    promotionInProgress: 'Promotion en cours ! Profitez de -{value}% jusqu\'au {endDate}',
    withCode: 'en utilisant le code :',
    allSubscriptions: 'sur tous nos abonnements',
    annualAndLifetime: 'sur nos abonnements annuel et à vie',
    benefitReduction: 'Bénéficiez de -{value}% {subscriptionType} en nous écrivant à l\'adresse contact@tokatab.com'
  },
  mobileNavBar: {
    home: 'Accueil',
    skills: 'Compétences',
    lessons: 'Leçons',
    pieces: 'Morceaux',
    challenges: 'Challenges'
  },
  desktopHeader: {
    midiTooltip: 'Utilisez votre clavier MIDI pour une meilleure expérience !',
    midiLabel: 'Clavier MIDI',
    midiConnected: '{deviceName} : connecté !',
    home: 'Accueil',
    pieces: 'Morceaux',
    challenges: 'Challenges',
    skills: 'Compétences',
    lessons: 'Leçons',
    progress: 'Progression'
  },
  notificationPermissionDeniedModal: {
    title: 'Activation des notifications',
    firstTimeDisabled: 'La première fois, vous avez désactivé les notifications, mais vous pouvez les réactiver à tout moment en vous rendant dans les paramètres via le bouton ci-dessous.',
    canLeaveDisabled: 'Vous pouvez également choisir de les laisser désactivées, mais dans ce cas, vous ne recevrez aucune notification.',
    dontActivate: 'Ne pas les activer',
    activateNotifications: 'Activer les notifications'
  },
  freemiumSubscriptionPopup: {
    quotaReached: 'Quota d\'import atteint',
    freeContentExhausted: 'Contenus gratuits épuisés',
    importUnlimited: 'Importez vos propres morceaux en illimité avec un abonnement Premium.',
    unlockToday: 'Débloquez dès aujourd\'hui un apprentissage sans limite pour moins de 5€ par mois.',
    perMonth: '/ mois',
    customPath: 'Parcours sur mesure',
    thousandContent: '1000+ contenus',
    unlimitedImport: 'Import illimité de partitions',
    unlimitedAll: 'Accès illimité à tous les contenus Tokatab (1000+ exercices, 100+ morceaux)',
    dailyRenewal: 'Vos 3 contenus offerts par jour se renouvellent tous les jours à minuit',
    weeklyRenewal: 'Vos 5 contenus offerts par semaine se renouvellent chaque lundi à minuit',
    nextRenewal: 'Prochain renouvellement : {date}',
    subscribeNow: 'S\'abonner maintenant',
    seeAllBenefits: 'Voir tous les avantages',
    limitedOffer: '🎹 OFFRE LIMITÉE -{promotion}%',
    importPiecesUnlimited: 'Importez vos morceaux',
    inUnlimited: 'en illimité',
    rightNow: 'dès maintenant',
    continuePlayingLearning: 'Continuez à jouer et',
    learn: 'apprendre',
    noLimitImport: 'Plus de limite sur l\'import de vos morceaux MusicXML personnels',
    unlimitedAccess: 'Accès illimité à tous les exercices, morceaux, challenges et à un parcours sur mesure',
    savePercent: 'ÉCONOMISEZ {promotion}%',
    everythingNeeded: 'Tout ce dont vous avez besoin pour',
    masterPiano: 'maîtriser le piano',
    satisfied: 'Plus de 5 000 apprenants satisfaits',
    dailyContentRenewal: '📆 Vos 3 contenus offerts par jour se renouvellent chaque jour à minuit',
    weeklyContentRenewal: '📆 Vos 5 contenus offerts par semaine se renouvellent chaque lundi à minuit',
    seeOtherSubscriptions: 'Voir les autres abonnements',
    cancelAnytime: 'Annulation à tout moment • Sans engagement',
    benefits: {
      unlimitedAccessTitle: 'Accès illimité',
      unlimitedAccess: 'Accès illimité à tous les contenus',
      virtualTeacherTitle: 'Professeur virtuel',
      virtualTeacher: 'Professeur virtuel personnalisé',
      progressTrackingTitle: 'Suivi de progression',
      progressTracking: 'Suivi détaillé de vos progrès',
      importPiecesTitle: 'Import de partitions',
      importPieces: 'Importez vos propres morceaux en illimité'
    },
    testimonials: {
      1: {
        text: 'Autodidacte depuis un an avec internet, je jouais surtout des morceaux juste à une main.. du coup là je suis content parce que les exercices me permettent de m\'entraîner à jouer les 2 en même temps ce que j\'arrivais pas à faire tout seul',
        author: 'Pierre Dardenne, par mail à l\'équipe Tokatab'
      },
      2: {
        text: 'J\'aime beaucoup, surtout quand l\'appli joue le son de l\'autre main que je ne joue pas. C\'est plus cool pour m\'entrainer et c\'est agreable à entendre',
        author: 'Posipi 83, sur le Play store'
      },
      3: {
        text: 'Votre méthode est efficace, mon jeu en accords à la main droite est bien meilleur que avant. Je joue avec aisance des morceaux que je pensais trop difficiles pour moi il y a encore quelques mois, comme par exemple georgia on my mind. Mon fils de 13 ans s\'est fait aussi fait un compte et a fait de jolis progrès. Merci à toute l\'équipe pour ce bon outil d\'apprentissage !',
        author: 'Marco78, par mail à l\'équipe Tokatab'
      },
      4: {
        text: 'Top appli ! Pour avoir testé plusieurs appli concurrentes, Tokatab est de loin la meilleure en terme d\'apprentissage technique du piano',
        author: 'Cassandre349, sur App store'
      },
      5: {
        text: 'Après 2 ans avec Tokatab j\'ai sauté le cap et j\'ai pris un prof, j\'avais besoin de passer ce cap. Il a trouvé que mes mains avaient déjà de bons réflexes et a cru que j\'avais déja pris des cours avant. Bref, merci à vous pour l\'application et même si je prends des cours à coté, je continue bien sur ma routine de 2 à 3 sessions par semaine avec tokatab 😉',
        author: 'Myriam, par mail à l\'équipe Tokatab'
      },
      6: {
        text: 'Cela faisait plusieurs années que j\'avais en projet, un jour, d\'apprendre le piano. Finalement, à 40 ans, j\'ai découvert presque par hasard l\'appli Tokatab, créée par un prof de piano pour apprendre le piano. Le prix de l\'abonnement est vraiment pas cher pour avoir un quasi prof de piano à la maison dispo 7/7 24/24. Les leçons sont progressives et m\'ont permis d\'avancer super vite en l\'espace de 2-3 mois, je veux dire j\'arrive à jouer avec 2 mains ! En plus on peut apprendre des morceaux ! Top!',
        author: 'Sarah, par mail à l\'équipe Tokatab'
      },
      7: {
        text: 'Parfait pour reprendre le piano à mon rythme. Après avoir pris des cours de piano dans ma jeunesse, Tokatab m\'a permis de m\'y remettre sans avoir à payer pour des cours en présentiel. Les leçons sont accessibles et adaptées à mon emploi du temps chargé. Une solution pratique et économique, j\'adore 🙂',
        author: 'Fanny Therry, sur le Play store'
      },
      8: {
        text: 'Contrairement aux autres applications, le vrai "plus" de Tokatab est que l\'app est pensée pour maîtriser son piano (avec des exercices, des maîtrises de certains gestes et positions…), et non pour uniquement jouer un morceau. Top !',
        author: 'HolivYeahhh, sur App store'
      },
      9: {
        text: 'Très bonne appli, les exercices sont super!',
        author: 'Qiao Qiao, sur le Play store'
      }
    }
  }
};